import Confetti from "react-confetti";
import { useSelector } from "react-redux";
import Typography from "../../../../../../../../common/Typography";
import { getFullImageUrl } from "../../../../../../../../../utils/constants/constants";
import useWindowDimensions from "../../../../../../../../../utils/CustomHooks/useWindowDimensions";

const CongratsScreen = ({ membership }) => {
  const { width, height } = useWindowDimensions();
  const initData = useSelector((state) => state?.shortLink?.initData);

  const textColor = membership?.landing_page_settings?.colors?.text ?? "#000";
  const themeColor =
    membership?.landing_page_settings?.colors?.theme ?? "#FFCA05";
  const logo = membership?.landing_page_settings?.logo;
  const storeName = initData?.store?.name;

  return (
    <div className="membership-purchased-congrats-screen">
      <div className="card-logo-parent">
        <div
          className="card-logo-div"
          style={{
            backgroundColor: textColor,
          }}
        >
          {logo?.length > 0 ? (
            <img
              src={getFullImageUrl(logo)}
              width="100px"
              alt="card-logo"
              title="Brand Logo"
              className="card-logo-image"
            />
          ) : (
            <Typography
              weight="medium"
              customClass="card-logo-name"
              style={{ color: themeColor }}
            >
              {storeName}
            </Typography>
          )}
        </div>
      </div>
      <div className="congrats-content">
        <Typography size="display-xl" weight="medium" customClass="congrats-text">
          Congratulations! 🥳
        </Typography>
        <hr className="divider" />
        <Typography
          size="display-md"
          weight="medium"
          customClass="congrats-subtext"
        >
          You've unlocked {membership?.landing_page_settings?.title} benefits.
        </Typography>
      </div>
      <Confetti
        width={width}
        height={height}
        recycle={true}
        numberOfPieces={100}
        tweenDuration={15000}
        className="confetti"
      />
    </div>
  );
};
export default CongratsScreen;
